<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-button variant="success" class="mb-2" @click="openDownloadModal">
                <i class="fa fa-download mr-2" />Download Excel
            </b-button>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-1"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template v-slot:empty>
                    Tidak ada tipe.
                </template>
            </b-table>
            <div class="text-muted small mb-3">
                * Angka didalam kurung untuk REPAIR adalah jumlah unit Repair yang memiliki SPB pending.<br />
                ** Total tidak termasuk status JUNK.
            </div>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                />
            </div>
        </div>
        <b-modal id="modal-download-status-per-type-count" title="Download Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-status-per-type-count',
    props: {
        categoryId: { type: String, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            show: 10,

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            downloadStatus: 0,
            downloadPath: ""

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems() {

            this.isBusy = true
            this.items = []

            return this.$axios.get("inventory/status-count-type/?categoryId=" + this.categoryId).then(res => {

                let data = res.data
                data.forEach(it => {
                    // Cari array data REPAIR
                    let repairArray = it.listEntry.find(ele => ele.name == "REPAIR")
                    repairArray.id = `${repairArray.id} (${it.repairWithSpb})`
                })

                this.items = data

                this.fields.push({ key: "name", label: "Nama Tipe" })

                res.data[0].listEntry.forEach((it, index) => {
                    let label = it.name
                    if(label == "REPAIR") {
                        label = "REPAIR*"
                    }

                    this.fields.push({ key: `listEntry[${index}].id`, label: label })
                })

                this.fields.push({ key: "total", label: "TOTAL**" })
                this.totalRows = res.data.length

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        openDownloadModal() {

            this.downloadStatus = 1
            this.downloadPath = ""

            this.$bvModal.show("modal-download-status-per-type-count")

            this.$axios.get("inventory/status-count-type/excel?categoryId=" + this.categoryId).then(res => {

                this.downloadPath = this.$BASE_FILE_PATH + res.data
                this.downloadStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-status-per-type-count")
            })

        }

    },

    created(){
        this.init()
    }
}
</script>
